module.exports = __webpack_public_path__ + "img/play-on.34aae6fa.svg";